import cx from 'clsx';
import { currency } from 'components/utils/formatters';
import { IProvider } from 'interfaces/graphql';
import React, { FC } from 'react';

import s from './StatisticsInfo.module.less';

interface Props {
  provider: IProvider;
}

export const StatisticsInfo: FC<Props> = ({ provider }) => {
  const delayedOrders = provider?.rank?.delayedProviderOrdersQuantity || 0;

  return (
    <div className={s.wrapper}>
      <div>
        <b>PO total</b>
      </div>
      <div>
        <b>{provider.performance?.totalOrdersCount}</b>
      </div>
      <div>
        <b>{currency(provider.performance?.totalOrdersValue)}</b>
      </div>
      <div>
        <span>In Production</span>
      </div>
      <div>
        <span>{provider.performance?.ordersInProductionCount}</span>
      </div>
      <div>
        <span>{currency(provider.performance?.ordersInProductionValue)}</span>
      </div>
      <div>
        <span>Delay POs</span>
      </div>
      <div>
        <span className={cx({ [s.delayedPos]: delayedOrders > 0 })}>{delayedOrders}</span>
      </div>
      <div></div>
      <div>
        <span>To be Paid</span>
      </div>
      <div>
        <span>{provider.performance?.ordersBePaidCount}</span>
      </div>
      <div>
        <span>{currency(provider.performance?.ordersBePaidValue)}</span>
      </div>
      <div>
        <span>Paid, Total</span>
      </div>
      <div>
        <span>{provider.performance?.ordersPaidCount}</span>
      </div>
      <div>
        <span>{currency(provider.performance?.ordersPaidValue)}</span>
      </div>
    </div>
  );
};
